export default __webpack_public_path__ + "static/amazonFires6-3318770e0b23b7cdcc57dcacf3b39b0b.gif";